module.exports = __webpack_public_path__ + "static/media/number3.959a8850.svg";